import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import MarkdownListDescription from '@/components/list/MarkdownListDescription';
import { approvalStatus } from '../constants';
import { resolveRequestWorkflow } from '../state/state';

const RequestStatusReasonListItem = ({
  reason,
  status,
}) => {
  if (status === approvalStatus.PENDING || !reason) {
    return null;
  }

  return (
    <List.Item className="aridhia-request-status-reason-list-item">
      <List.Header>
        <FormattedMessage id="request.list.action.reason.title" />
      </List.Header>
      <MarkdownListDescription value={reason} className="aridhia-form-item-description" />
    </List.Item>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { status: '', action_reason: '' });

  return (
    {
      status: request.status,
      reason: request.action_reason,
    }
  );
};

export default connect(mapStateToProps)(RequestStatusReasonListItem);
